export const cardActionsProps = {
    class: 'justify-center pb-8',
}
